export const clarityFramingQuestions = [
  'Why do many American Christians support Trump?',
  'If things are so bad, why are many Americans okay with it?',
] as const;
